import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sn-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss'],
})
export class VideoDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    private readonly _matDialogRef: MatDialogRef<VideoDialogComponent>,
  ) {}

  public ngOnInit(): void {}

  public cancel(): void {
    this._matDialogRef.close();
  }
}
